import classNames from "classnames";
import { AiOutlineWarning } from "react-icons/ai";

interface FormGroupLabelProps {
  className?: string;
  children: React.ReactNode;
  marginBottom?: boolean;
  marginLeft?: boolean;
  noUpperCase?: boolean;
  warningLabel?: boolean;
}

export const FormGroupLabel: React.FC<FormGroupLabelProps> = ({
  className,
  children,
  marginBottom,
  marginLeft,
  noUpperCase,
  warningLabel,
}) => {
  const warningStyle = "text-primary";
  return (
    <div
      className={classNames(
        className,
        "flex items-center text-regular-3 cursor-default font-light text-left",
        warningLabel ? warningStyle : "text-muted-foreground",
        marginBottom && "mb-2",
        marginLeft && "ml-2"
      )}
      role="group"
    >
      {warningLabel && <AiOutlineWarning className="mr-1" aria-hidden="true" focusable="false" />}
      <div
        className={classNames(noUpperCase ? "" : "uppercase")}
        aria-label={warningLabel ? "Warning Label" : undefined}
      >
        {children}
      </div>
    </div>
  );
};

export default FormGroupLabel;
